var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((1000),function(num){return _c('div',{key:num,staticClass:"circle-container"},[_c('div',{staticClass:"circle"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }